export default {
  sex: {
    male: 'Männlich',
    female: 'Weiblich',
    other: 'Andere',
    unknown: 'Unbekannt',
  },
}
